import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";

function Checkuser() {
  const dealer_id = localStorage.getItem("dealer_id");
  const token = localStorage.getItem("token");
  const { remark } = useParams();
  const navigate = useNavigate();
  const dealerloginmobile = localStorage.getItem("dealer_login_mobile") || "";
  const server_url = localStorage.getItem("server_url") || "";
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [subCities, setSubCities] = useState([]);

  const [profile, setProfile] = useState({
    dealer_is_retailer: "1", // 1 for Dealer, 2 for Retailer
    dealer_firm_name: "",
    dealer_owner_name: "",
    dealer_owner_contact: "",
    dealer_login_mobile: dealerloginmobile,
    dealer_order_varification_mobile: "",
    dealer_email: "",
    dealer_address: "",
    dealer_pincode: "",
    dealer_pan_number: "",
    dealer_gst_number: "",
    dealer_id,
    company_id: "2",
    dealer_pan_document: "",
    dealer_gst_document: "",
    dealer_pdc_check: "",
    dealer_showroom_image: "",
    dealer_remark: "",
    dealer_contact_person_name: "",
    dealer_state_id: "",
    dealer_city_id: "",
    dealer_sub_city_id: "",
  });

  useEffect(() => {
    fetchStates();
    fetchProfileData();

    const handlePopState = () => {
      if (isSubmitting) window.history.go(1);
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [isSubmitting]);

  useEffect(() => {
    if (profile.dealer_state_id && profile.dealer_state_id !== "") {
      fetchCities(profile.dealer_state_id);
    }

    if (profile.dealer_city_id && profile.dealer_city_id !== "") {
      fetchSubCities(profile.dealer_city_id);
    }
  }, [profile.dealer_state_id, profile.dealer_city_id]);

  useEffect(() => {
    const gst = profile.dealer_gst_number;
    if (gst && gst.length >= 12) {
      const pan = gst.substring(2, 12); // characters 3 to 12
      setProfile((prev) => ({
        ...prev,
        dealer_pan_number: pan,
      }));
    }
  }, [profile.dealer_gst_number]);

  const fetchProfileData = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_mobile", dealerloginmobile);
      const response = await axios.post(
        `${server_url}my_profile.php`,
        formData
      );
      if (response.data.status === "1") {
        setProfile((prev) => ({ ...prev, ...response.data.result[0] }));
      } else {
        toast.error(response.data.error || "Failed to fetch profile.");
      }
    } catch {
      toast.error("Network error! Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchStates = async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      const response = await axios.post(`${server_url}state.php`, formData);
      if (response.data.status === "1") {
        setStates(
          response.data.result.map((s) => ({
            value: s.state_id,
            label: s.state_name,
          }))
        );
      }
    } catch {
      toast.error("Failed to load states.");
    }
  };

  const fetchCities = async (state_id) => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("state_id", state_id);
      const response = await axios.post(`${server_url}city.php`, formData);
      if (response.data.status === "1") {
        setCities(
          response.data.result.map((c) => ({
            value: c.city_id,
            label: c.city_name,
          }))
        );
      }
    } catch {
      toast.error("Failed to load cities.");
    }
  };

  const fetchSubCities = async (city_id) => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("city_id", city_id);
      const response = await axios.post(`${server_url}sub_city.php`, formData);
      if (response.data.status === "1") {
        setSubCities(
          response.data.result.map((s) => ({
            value: s.sub_city_id,
            label: s.sub_city_name,
          }))
        );
      }
    } catch {
      toast.error("Failed to load sub-cities.");
    }
  };

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setProfile({ ...profile, [name]: files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const formData = new FormData();
      Object.keys(profile).forEach((key) => formData.append(key, profile[key]));
      const response = await axios.post(
        `${server_url}update_dealer_details.php`,
        formData
      );

      if (response.data.status === "1") {
        await check_user();
        await Add_order();
      } else {
        toast.error(response.data.error || "Update failed.");
      }
    } catch {
      toast.error("Error during update.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const check_user = async () => {
    const formData = new FormData();
    formData.append("company_id", "2");
    formData.append("dealer_id", dealer_id);
    formData.append("device_token", token);
    const res = await axios.post(`${server_url}check_dealer.php`, formData);
    const result = res.data.result?.[0] || {};
    if (res.data.status === "1") {
      Object.entries(result).forEach(([k, v]) => localStorage.setItem(k, v));
    }
  };

  const Add_order = async () => {
    const formData = new FormData();
    formData.append("company_id", "2");
    formData.append("dealer_id", dealer_id);
    formData.append("depo_id", "");
    formData.append("order_description", remark);
    const res = await axios.post(`${server_url}add_order.php`, formData);
    if (res.data.status === "1") {
      navigate(`/MyOrderds`);
    } else {
      toast(res.data.error);
    }
  };

  const renderPreview = (file) => {
    if (!file) return null;
    const fileUrl = typeof file === "string" ? file : URL.createObjectURL(file);
    return fileUrl.toLowerCase().endsWith(".pdf") ? (
      <div className="file-preview" style={{ borderRadius: "12px" }}>
        <iframe src={fileUrl} className="preview-iframe" />
        <p className="preview-label">Document Preview</p>
      </div>
    ) : (
      <div className="file-preview" style={{ borderRadius: "12px" }}>
        <img src={fileUrl} alt="preview" className="preview-image" />
        <p className="preview-label">Image Preview</p>
      </div>
    );
  };

  const isRetailer = profile.dealer_is_retailer === "2";

  // Custom styles for react-select - Updated for white theme
  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#ffffff",
      borderColor: state.isFocused ? "#ff483a" : "#ddd",
      color: "#333",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(255, 72, 58, 0.1)" : "none",
      "&:hover": {
        borderColor: state.isFocused ? "#ff483a" : "#bbb",
      },
      minHeight: "52px",
      borderRadius: "12px",
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#ffffff",
      border: "1px solid #ddd",
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f5f5f5" : "#ffffff",
      color: "#333",
      "&:active": {
        backgroundColor: "#f5f5f5",
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: "#333",
    }),
    input: (base) => ({
      ...base,
      color: "#333",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#999",
    }),
  };

  return (
    <div className="page-wrapper">
      <div className="sticky-header">
        <Header />
      </div>

      <div className="checkuser-content">
        <div className="checkuser-container">
          <div className="checkuser-card">
            <div className="checkuser-card-header">
              <h1>Complete Your Profile</h1>
            </div>

            <div className="checkuser-form-container">
              {loading ? (
                <div className="loading-state">
                  <div className="spinner"></div>
                  <p>Loading your profile...</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  {/* Customer Type Selection */}
                  <div className="input-group full-width">
                    <label>Customer Type</label>
                    <div className="radio-group">
                      <label className="radio-label">
                        <input
                          type="radio"
                          name="dealer_is_retailer"
                          value="1"
                          checked={profile.dealer_is_retailer === "1"}
                          onChange={handleChange}
                          className="radio-input"
                        />
                        <span className="radio-custom"></span>
                        Dealer/Distributor
                      </label>
                      <label className="radio-label">
                        <input
                          type="radio"
                          name="dealer_is_retailer"
                          value="2"
                          checked={profile.dealer_is_retailer === "2"}
                          onChange={handleChange}
                          className="radio-input"
                        />
                        <span className="radio-custom"></span>
                        Retailer
                      </label>
                    </div>
                  </div>

                  {/* Conditional Fields based on Customer Type */}
                  {isRetailer ? (
                    <div className="input-group full-width">
                      <label>Contact Person Name</label>
                      <input
                        name="dealer_contact_person_name"
                        value={profile.dealer_contact_person_name}
                        onChange={handleChange}
                        placeholder="Enter contact person name"
                        className="form-input"
                        required
                        style={{ borderRadius: "12px" }}
                      />
                    </div>
                  ) : (
                    <>
                      <div className="form-grid">
                        <div className="input-group">
                          <label>Firm Name</label>
                          <input
                            name="dealer_firm_name"
                            value={profile.dealer_firm_name}
                            onChange={handleChange}
                            placeholder="Enter firm name"
                            className="form-input"
                            required
                            style={{ borderRadius: "12px" }}
                          />
                        </div>

                        <div className="input-group">
                          <label>Owner Name</label>
                          <input
                            name="dealer_owner_name"
                            value={profile.dealer_owner_name}
                            onChange={handleChange}
                            placeholder="Enter owner name"
                            className="form-input"
                            required
                            style={{ borderRadius: "12px" }}
                          />
                        </div>

                        <div className="input-group">
                          <label>Owner Contact</label>
                          <input
                            type="number"
                            name="dealer_owner_contact"
                            value={profile.dealer_owner_contact}
                            onChange={handleChange}
                            placeholder="Enter owner contact"
                            className="form-input"
                            required
                            style={{ borderRadius: "12px" }}
                          />
                        </div>

                        <div className="input-group">
                          <label>Remark</label>
                          <input
                            name="dealer_remark"
                            value={profile.dealer_remark}
                            onChange={handleChange}
                            placeholder="Enter remark"
                            className="form-input"
                            style={{ borderRadius: "12px" }}
                          />
                        </div>
                      </div>

                      <div className="input-group full-width">
                        <label>Showroom Image</label>
                        <div className="file-upload">
                          <input
                            type="file"
                            name="dealer_showroom_image"
                            onChange={handleFileChange}
                            className="file-input"
                            accept="image/*"
                            style={{ borderRadius: "12px" }}
                          />
                          <div className="file-hint">JPG, PNG (Max 5MB)</div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Location Fields */}
                  <div className="form-grid">
                    <div className="input-group">
                      <label>State</label>
                      <Select
                        options={states}
                        value={states.find(
                          (s) => s.value === profile.dealer_state_id
                        )}
                        onChange={(e) => {
                          setProfile({
                            ...profile,
                            dealer_state_id: e.value,
                            dealer_city_id: "", // Clear city
                            dealer_sub_city_id: "", // Clear sub city
                          });
                          fetchCities(e.value);
                        }}
                        placeholder="Select State"
                        styles={customSelectStyles}
                      />
                    </div>

                    <div className="input-group">
                      <label>City</label>
                      <Select
                        options={cities}
                        value={cities.find(
                          (c) => c.value === profile.dealer_city_id
                        )}
                        onChange={(e) => {
                          setProfile({
                            ...profile,
                            dealer_city_id: e.value,
                            dealer_sub_city_id: "", // Clear sub city
                          });
                          fetchSubCities(e.value);
                        }}
                        placeholder="Select City"
                        styles={customSelectStyles}
                      />
                    </div>

                    <div className="input-group">
                      <label>Sub City</label>
                      <Select
                        options={subCities}
                        value={subCities.find(
                          (sc) => sc.value === profile.dealer_sub_city_id
                        )}
                        onChange={(e) =>
                          setProfile({
                            ...profile,
                            dealer_sub_city_id: e.value,
                          })
                        }
                        placeholder="Select Sub City"
                        styles={customSelectStyles}
                      />
                    </div>
                  </div>

                  {/* GST Fields (Dealer Only) */}
                  {!isRetailer && (
                    <>
                      <div className="form-grid">
                        <div className="input-group">
                          <label>GST Number</label>
                          <input
                            name="dealer_gst_number"
                            value={profile.dealer_gst_number}
                            onChange={handleChange}
                            placeholder="Enter GST number"
                            className="form-input"
                            required
                            style={{ borderRadius: "12px" }}
                          />
                        </div>
                        <div className="input-group">
                          <label>PAN Number</label>
                          <input
                            name="dealer_pan_number"
                            value={profile.dealer_pan_number}
                            onChange={handleChange}
                            placeholder="Enter PAN number"
                            className="form-input"
                            style={{ borderRadius: "12px" }}
                            required
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {/* PAN Fields */}
                  <div className="form-grid">
                    <div className="input-group">
                      <label>GST Document</label>
                      <div className="file-upload">
                        <input
                          type="file"
                          name="dealer_gst_document"
                          onChange={handleFileChange}
                          className="file-input"
                          accept=".pdf,.jpg,.jpeg,.png"
                          style={{ borderRadius: "12px" }}
                        />
                        <div className="file-hint">PDF, JPG, PNG (Max 5MB)</div>
                      </div>
                      {renderPreview(profile.dealer_gst_document)}
                    </div>

                    <div className="input-group">
                      <label>PAN Document</label>
                      <div className="file-upload">
                        <input
                          type="file"
                          name="dealer_pan_document"
                          onChange={handleFileChange}
                          className="file-input"
                          accept=".pdf,.jpg,.jpeg,.png"
                          style={{ borderRadius: "12px" }}
                        />
                        <div className="file-hint">PDF, JPG, PNG (Max 5MB)</div>
                      </div>
                      {renderPreview(profile.dealer_pan_document)}
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="button-container">
                    <button
                      type="submit"
                      className="submit-button"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Processing..." : "Submit & Continue"}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />

      {/* Loading Overlay */}
      {isSubmitting && (
        <div className="submission-overlay">
          <div className="overlay-content">
            <div className="overlay-spinner"></div>
            <p>Please wait... Order placing</p>
          </div>
        </div>
      )}

      <style jsx>{`
        .css-1xc3v61-indicatorContainer {
          background: #ffffff !important;
          border: 0px solid #ddd !important;
        }
        .page-wrapper {
          min-height: 100vh;
          background: #ffffff;
          display: flex;
          flex-direction: column;
        }

        .sticky-header {
          position: sticky;
          top: 0;
          z-index: 1000;
          width: 100%;
        }

        .checkuser-content {
          flex: 1;
          padding: 20px 15px;
          min-height: calc(100vh - 80px);
          margin-bottom: ${isMobile ? "70px" : "0"};
          background: #ffffff;
        }

        .checkuser-container {
          max-width: 900px;
          margin: 0 auto;
          width: 100%;
        }

        .checkuser-card {
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          border: 1px solid #e0e0e0;
          overflow: hidden;
        }

        .checkuser-card-header {
          padding: 30px 25px 20px;
          border-bottom: 1px solid #f0f0f0;
          background: #ffffff;
        }

        .checkuser-card-header h1 {
          color: #333;
          font-size: 24px;
          font-weight: 600;
          margin: 0 0 8px 0;
          text-align: center;
        }

        .checkuser-card-header p {
          color: #666;
          font-size: 14px;
          margin: 0;
          line-height: 1.5;
          text-align: center;
        }

        .checkuser-form-container {
          padding: 25px;
        }

        .form-grid {
          display: flex;
          flex-direction: column;
          gap: 20px;
          margin-bottom: 20px;
          margin-top: 20px;
        }

        .input-group {
          display: flex;
          flex-direction: column;
        }

        .input-group.full-width {
          width: 100%;
        }

        .input-group label {
          color: #333;
          font-weight: 600;
          margin-bottom: 10px;
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .form-input {
          background: #ffffff;
          border: 1px solid #ddd;
          border-radius: 10px;
          padding: 14px 16px;
          color: #333;
          font-size: 15px;
          transition: all 0.3s ease;
          font-family: inherit;
          width: 100%;
          box-sizing: border-box;
        }

        .form-input:focus {
          outline: none;
          border-color: #ff483a;
          box-shadow: 0 0 0 3px rgba(255, 72, 58, 0.1);
        }

        /* Radio Group Styles */
        .radio-group {
          display: flex;
          flex-direction: column;
          gap: 15px;
          padding: 15px;
          background: #f9f9f9;
          border-radius: 12px;
        }

        .radio-label {
          display: flex;
          align-items: center;
          gap: 12px;
          color: #333;
          cursor: pointer;
          font-weight: 500;
        }

        .radio-input {
          display: none;
        }

        .radio-custom {
          width: 20px;
          height: 20px;
          border: 2px solid #bbb;
          border-radius: 50%;
          position: relative;
          transition: all 0.3s ease;
        }

        .radio-input:checked + .radio-custom {
          border-color: #ff483a;
          background: #ff483a;
        }

        .radio-input:checked + .radio-custom::after {
          content: "";
          width: 8px;
          height: 8px;
          background: #fff;
          border-radius: 50%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        /* File Upload Styles */
        .file-upload {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .file-input {
          cursor: pointer;
          padding: 12px;
          background: #ffffff;
          border: 1px solid #ddd;
          border-radius: 10px;
          color: #333;
          font-size: 14px;
        }

        .file-input::-webkit-file-upload-button {
          background: #f5f5f5;
          border: 1px solid #ddd;
          color: #333;
          padding: 8px 16px;
          border-radius: 6px;
          cursor: pointer;
          margin-right: 12px;
          font-weight: 500;
          transition: background 0.3s ease;
        }

        .file-input::-webkit-file-upload-button:hover {
          background: #e9e9e9;
        }

        .file-hint {
          color: #888;
          font-size: 12px;
          font-style: italic;
        }

        /* File Preview Styles */
        .file-preview {
          margin-top: 15px;
          padding: 15px;
          background: #f9f9f9;
          border-radius: 8px;
          border: 1px solid #e0e0e0;
        }

        .preview-iframe {
          width: 100%;
          height: 200px;
          border-radius: 8px;
          border: 1px solid #ddd;
        }

        .preview-image {
          width: 100%;
          max-height: 200px;
          border-radius: 8px;
          border: 1px solid #ddd;
          object-fit: contain;
        }

        .preview-label {
          color: #888;
          font-size: 12px;
          margin-top: 8px;
          text-align: center;
        }

        /* Button Styles */
        .button-container {
          width: 100%;
          text-align: center;
          padding-top: 20px;
          border-top: 1px solid #f0f0f0;
        }

        .submit-button {
          background: linear-gradient(135deg, #ff483a 0%, #e53935 100%);
          color: white;
          border: none;
          padding: 16px 40px;
          border-radius: 10px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          width: 100%;
          max-width: 300px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .submit-button:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(255, 72, 58, 0.4);
        }

        .submit-button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        /* Loading States */
        .loading-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 20px;
          color: #333;
          padding: 40px 0;
        }

        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid #f0f0f0;
          border-left: 4px solid #ff483a;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        .submission-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.95);
          z-index: 9999;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .overlay-content {
          text-align: center;
          color: #333;
        }

        .overlay-spinner {
          width: 50px;
          height: 50px;
          border: 4px solid #f0f0f0;
          border-left: 4px solid #ff483a;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 20px;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        /* Desktop Styles */
        @media (min-width: 768px) {
          .checkuser-content {
            padding: 30px 20px;
          }

          .checkuser-card-header {
            padding: 40px 50px 30px;
          }

          .checkuser-card-header h1 {
            font-size: 32px;
            text-align: left;
          }

          .checkuser-card-header p {
            font-size: 16px;
            text-align: left;
          }

          .checkuser-form-container {
            padding: 50px;
          }

          .form-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 30px;
            margin-bottom: 30px;
          }

          .input-group.full-width {
            grid-column: 1 / -1;
          }

          .radio-group {
            flex-direction: row;
            gap: 30px;
          }

          .submit-button {
            width: auto;
            min-width: 220px;
            padding: 16px 50px;
          }
        }

        /* Large Desktop Styles */
        @media (min-width: 1024px) {
          .checkuser-container {
            max-width: 900px;
          }
        }

        /* Mobile Optimizations */
        @media (max-width: 767px) {
          .checkuser-card {
            margin-top: 70px;
            border-radius: 12px;
          }

          .checkuser-card-header {
            padding: 25px 20px 15px;
          }

          .checkuser-form-container {
            padding: 20px;
          }

          .form-grid {
            gap: 15px;
            margin-bottom: 15px;
          }

          .form-input {
            padding: 12px 14px;
            font-size: 14px;
          }

          .submit-button {
            padding: 14px 30px;
            font-size: 15px;
          }

          /* Touch optimizations for mobile */
          @media (hover: none) and (pointer: coarse) {
            .submit-button:hover:not(:disabled) {
              transform: none;
            }
          }
        }

        /* Very small screens */
        @media (max-width: 360px) {
          .checkuser-content {
            padding: 15px 10px;
          }

          .checkuser-card-header {
            padding: 20px 15px 12px;
          }

          .checkuser-card-header h1 {
            font-size: 20px;
          }

          .checkuser-form-container {
            padding: 15px;
          }

          .form-grid {
            gap: 12px;
          }
        }
      `}</style>
    </div>
  );
}

export default Checkuser;